export const CARRIER_RETURN = 'carrier_return'
export const CUSTOMER_RETURN = 'customer_return'

export const RETURN_TYPE = {
  [CARRIER_RETURN]: 'Carrier return',
  [CUSTOMER_RETURN]: 'Customer return'
}

export const FILTER_NAME = 'customer_return'
